import React from 'react';
import { Outlet } from 'react-router-dom';
import { BottomNav } from './BottomNav';
export function MainLayout() {
  return <div className="w-full h-full relative bg-black" data-id="element-126">
      <div className="w-full h-full overflow-y-auto no-scrollbar pb-[72px]" data-id="element-127">
        <Outlet data-id="element-128" />
      </div>
      <BottomNav data-id="element-129" />
    </div>;
}